import { ChangeDetectionStrategy, Component } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-validator',
  template: '',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValidatorComponent {
  public dateFormat = 'DD-MM-YYYY';
  public hidePassword = true;
  public hideConfirmPassword = true;
  public hideCurrentPassword = true;

  public restrictToNumbers(event: KeyboardEvent): void {
    const input = event.key;
    const currentValue = (event.target as HTMLInputElement).value;
    const proposedValue = currentValue + input;
    const validNumberPattern = /^[0-9]+\.?[0-9]*$/;
    if (
      !validNumberPattern.test(proposedValue) &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(input)
    ) {
      event.preventDefault();
    }
  }

  public restrictToStrings(event: KeyboardEvent): void {
    const input = event.key;
    if (!/^[a-zA-Z\s]$/.test(input) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(input)) {
      event.preventDefault();
    }
  }
  public onStandardisedCalendarDateSelect(e: any, control: string, index: any, key: any): void {
    const date = moment(e).format(this.dateFormat);
    (this as any)[control].controls[index].controls[key].setValue(date);
  }

  public showCurrentPasswordToggle(): void {
    this.hideCurrentPassword = !this.hideCurrentPassword;
  }
  public showPasswordToggle(): void {
    this.hidePassword = !this.hidePassword;
  }
  public showConfirmPasswordToggle(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  public uppercaseValidator(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      const hasUppercase = /[A-Z]/.test(control.value);
      return hasUppercase ? null : { uppercase: true };
    };
  }

  public abnStatusCheck(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      return control.value?.toLowerCase() === 'active' ? null : { inactive: true };
    };
  }

  public lowercaseValidator(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      const hasLowercase = /[a-z]/.test(control.value);
      return hasLowercase ? null : { lowercase: true };
    };
  }

  public numberValidator(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      const hasNumber = /[0-9]/.test(control.value);
      return hasNumber ? null : { number: true };
    };
  }

  public specialCharacterValidator(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(control.value);
      return hasSpecialCharacter ? null : { specialCharacter: true };
    };
  }

  public noSpacesValidator(): (control: { value: string }) => Record<string, boolean> | null {
    return (control: { value: string }) => {
      if (/\s/.test(control.value)) {
        return { hasSpace: true };
      }
      return null;
    };
  }

  public stateShortCuts(state: string): string {
    switch (state) {
      case 'New South Wales':
        return 'NSW';
      case 'Victoria':
        return 'VIC';
      case 'Queensland':
        return 'QLD';
      case 'South Australia':
        return 'SA';
      case 'Western Australia':
        return 'WA';
      case 'Tasmania':
        return 'TAS';
      case 'Australian Capital Territory':
        return 'ACT';
      case 'Northern Territory':
        return 'NT';
      default:
        return this.convertToInitials(state);
    }
  }

  public convertToInitials(value: any): string {
    if (!value) {
      return value;
    }
    const words = value.split(' ');
    let initials = [];
    if (words.length > 1) {
      initials = words.map((word: any) => word.charAt(0));
    } else {
      initials = words.map((word: any) => word.slice(0, 3));
    }
    return initials.join('').toUpperCase();
  }

  public convertToService(value: any): string {
    switch (value) {
      case 'Physiotherapist':
        return 'Physiotherapy';
      default:
        return value;
    }
  }
}
